export default [
  {
    title: "Dashboard",
    icon: "HomeIcon",
    route: "admin-dash",
    resource: "Invoice",
    action: "manage",
  },
];
